<template>
  <div id="profile">
    <div class="p-col-6 p-offset-3">
      <h2>Maintain User Profile</h2>
    </div>
    <Fieldset class="p-shadow-8">
      <DataTable
        :value="usersRef"
        :paginator="true"
        class="p-datatable-customers"
        :rows="10"
        dataKey="id"
        :filters="filters"
        :loading="loading"
      >
        <template #header>
          <div class="table-header">
            List of Customers
            <span class="p-input-icon-left">
              <i class="pi pi-search" />

            </span>
          </div>
        </template>
        <template #empty> No customers found. </template>
        <template #loading> Loading customers data. Please wait. </template>
        <Column field="lastname" header="lastName">
          <template #body="slotProps">
            <span class="p-column-title">Name</span>
            {{ slotProps.data.name }}
          </template>
          <template #filter>
            <InputText
              type="text"
              v-model="filters['lastname']"
              class="p-column-filter"
              placeholder="Search by name"
            />
          </template>
        </Column>
      </DataTable>
    </Fieldset>
  </div>
</template>

<script>
var userRef = fb_db.collection("users");
import { fb_auth, fb_db } from "../firebase";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
export default {
  name: "OpDashboard",
  components: {
    DataTable,
    Column,
  },
  data() {
    return userRef
      .doc()
      .get()
      .then(function (doc) {});
  },
  methods: {
    logoutUser() {
      fb_auth
        .signOut()
        .then(() => {
          //sign-out successful.
          this.$router.push({ path: "/" });
        })
        .catch(function (error) {
          //an error happened
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#dashboard {
  color: #999999;
}
</style>